import {
  getEngineerFiltersFromStorage,
  hasAnyNonDateEngineerFilter,
  normalizeEngineerStatusesForReport,
} from "../utils/engineerFilters";
import {
  downloadReport,
} from "../utils/reportDownload";

export {
  MISSING_PERIOD_MESSAGE as MISSING_PERIOD_MESSAGE_ENGINEER,
} from "../utils/reportDownload";

export const useEngineerReportDownload = (
  setIsDownloading: (v: boolean) => void,
  setBackgroudError: (v: string) => void,
) => {
  const download = () =>
    downloadReport({
      getFilters: getEngineerFiltersFromStorage,
      hasAnyNonDateFilter: hasAnyNonDateEngineerFilter,
      endpoint: "/report/engineer",
      setIsDownloading,
      setBackgroudError,
      normalizeStatuses: normalizeEngineerStatusesForReport,
    });

  return { download };
};
